module.exports = __webpack_public_path__ + "static/media/ic-ad-banner30.2abacda7.png";